import Head from 'next/head';
import { Header, Footer, Plain } from '@components';
import { Box, Flex } from '@chakra-ui/react';

export function HowToPage() {
  return (
    <Flex direction={'column'} minH={'100vh'}>
      <Head>
        <title>
          Jak zamawiać | IKSEL Studio Reklamy - Reklama dla Twojej firmy
        </title>

        <meta
          name="description"
          content="IKSEL Studio Reklamy - Jak zamówić projekt, realizację lub wydruk. Szczegółowe porady i pomoc z naszej strony. Kompleksowa obsługa reklamowa i kampanie marketingowe"
        />
      </Head>

      <Header
        id="header"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        menu={{
          elements: [
            {
              id: 'header-strona-glowna-link',
              label: 'Strona główna',
              href: '/',
            },
            {
              id: 'header-oferta-link',
              label: 'Oferta',
              href: '/#oferta',
            },
            {
              id: 'header-aktualnosci-link',
              label: 'Aktualności',
              href: 'https://www.facebook.com/IKSEL.reklama',
            },
            {
              id: 'header-kontakt-link',
              label: 'Kontakt',
              href: '/kontakt',
            },
          ],
        }}
      />

      <Box flex={1}>
        <Plain
          id="jak-zamawiac"
          title="Jak zamawiać"
          subtitle="Nie potrzebujesz zakładać konta, aby przeglądać naszą ofertę"
          html={`
            <h3>Wszystkie produkty możesz dodawać do koszyka w celu uzyskania oferty cenowej.</h3>
            <p>Zam&oacute;wienia można składać drogą e-mailową powołując się na otrzymaną ofertę.</p>
            <ol>
            <li>Po wybraniu produktu wraz z przypisanymi do niego atrybutami, towar dodawany jest automatycznie do koszyka.</li>
            <li>Na tym etapie składania zapytania Klient może zakończyć proces wysyłania zapytania lub je kontynuować poprzez powr&oacute;t do listy towar&oacute;w.</li>
            <li>Po wybraniu wszystkich interesujących produkt&oacute;w należy przejść do koszyka zapytań.</li>
            <li>Następnie potwierdzamy zapytanie jednocześnie sprawdzając wszystkie dane.</li>
            <li>W przypadku braku zastrzeżeń potwierdzamy klikając &bdquo;Wyślij zapytanie&rdquo;.</li>
            <li>W tym momencie drogą mailową Klient otrzyma następujące informacje:</li>
            <ul>
            <li>numer oferty</li>
            <li>łączną kwotę do zapłaty</li>
            <li>formy płatności</li>
            <li>dane teleadresowe do ewentualnego kontaktu ze sklepem</li>
            </ul>
            <li>Po potwierdzeniu zam&oacute;wienia na podany wcześniej adres e-mail, klient otrzyma potwierdzenie dokonania zakup&oacute;w w sklepie, z informacjami dotyczącymi ilości, rodzaju zakupionych produkt&oacute;w, sposobem wysyłki, kwotą łączną do zapłaty w postaci faktury Pro-forma.</li>
            </ol>`}
        />
      </Box>

      <Footer
        id="footer"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        categories={[
          {
            name: 'Zasady',
            elements: [
              {
                text: 'Polityka prywatności',
                href: '/polityka-prywatnosci',
              },
              {
                text: 'Płatność i dostawa',
                href: '/platnosc-i-dostawa',
              },
              {
                text: 'FAQ',
                href: '/faq',
              },
            ],
          },
          {
            name: 'Pomoc',
            elements: [
              {
                text: 'Jak zamawiać?',
                href: '/jak-zamawiac',
              },
              {
                text: 'Akceptowalne pliki',
                href: '/akceptowalne-pliki',
              },
              {
                text: 'Projektowanie',
                href: '/projektowanie',
              },
            ],
          },
        ]}
      />
    </Flex>
  );
}

export default HowToPage;
